import { render } from "./PdfMangelInputPageEnsimimav.vue?vue&type=template&id=4b0d5271&scoped=true&ts=true"
import script from "./PdfMangelInputPageEnsimimav.vue?vue&type=script&lang=ts"
export * from "./PdfMangelInputPageEnsimimav.vue?vue&type=script&lang=ts"

import "./PdfMangelInputPageEnsimimav.vue?vue&type=style&index=0&id=4b0d5271&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0d5271"]])

export default __exports__